var _effectorFileName = "/src/features/quiz/components/quiz-contact-form.tsx";
import { useUnit } from 'effector-react';
import { useQuizContext } from '@/features/quiz/quiz-context';
import { ContactForm } from '@/shared/components/contact-form/contact-form';
import { quizFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData } from '@/shared/components/contact-form/types';
export interface QuizContactFormData extends ContactFormData {
  quizResult: string;
}
interface QuizContactFormProps {
  quizResult?: string;
}
export const QuizContactForm = (props: QuizContactFormProps) => {
  const {
    quizResult
  } = props;
  const {
    onQuizFormDataSend
  } = useUnit({
    onQuizFormDataSend: quizFormDataSent
  });
  const {
    onContactFormSubmit
  } = useQuizContext();
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSubmit();
    onQuizFormDataSend({
      ...data,
      quizResult: quizResult ?? ''
    });
  };
  return <ContactForm entryPoint="GROUP_LESSONS_QUIZ" buttonText="Получить результаты" onFormSubmit={handleContactFormSubmit} />;
};